import { render, staticRenderFns } from "./SiteNavDesktopV2.vue?vue&type=template&id=de5ec0e6&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2.vue?vue&type=style&index=0&id=de5ec0e6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5ec0e6",
  null
  
)

export default component.exports